module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": require("../../assets/posters/aBrightFutureForKids.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("A Bright Future For Kids")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2016-2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("A Bright Future for Kids targets the core causes of poverty by embracing a holistic approach for lasting transformation that secures a bright future for underprivileged communities.  Their outreach team in Ethiopia and in Kenya are currently working with families in an effort to change their current situations to provide pathways to success. This ranges from providing school supplies for kids to helping parents build a small business that will provide for their families through the small scale business venture.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": require("../../assets/projects/a-bright-future-for-kids/aBrightFutureForKidsTestimonial.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("Solomon Dabe")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Founder of A Bright Future For Kids")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Traveling with Derek was more than filming; for me it was being sent to do kingdom work along side a brother in Christ.  During the whole video production process Derek took much time to have lengthy discussions on not only the project for him to understand the whole story of the organization and to try to understand every detail.  Derek serves passionately, gives his everything, and performed excellent work for our organization that has been much needed.\n      "), _c('br'), _c('br'), _vm._v("The impact of the final videos has just begun for us, but I believe these videos that Famous King has provided for us will give a way of exposing the dark places in the areas we work and bring a powerful message.  God for sure crossed our paths for a reason.  I thank God and am grateful for Famous King to come along side of ABF4K.  We would not have been able to videos or videos of such quality otherwise.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-096f8c1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/ABrightFutureForKids.vue
// module id = 70
// module chunks = 0